export default __webpack_public_path__ + "static/kBlock-94bd163e9d3426d96e36a720ca9da8fc.svg";